module.exports = __webpack_public_path__ + "static/img/26.eb65cd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/26.jpg
// module id = 1Fwt
// module chunks = 0